<template>
  <div class="w-100 mt-5 text-center">
    <a href="https://usetoggle.com" target="_blank">
      <img src="../assets/toggle_logo.svg" alt="Toggle logo" class="logo">
    </a>
    <p class="pt-2 info-text">
      Every brand here is powered by <a href="https://usetoggle.com" target="_blank">usetoggle.com</a>
    </p>
    
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.info-text,
a {
  font-family: 'Manrope';
  color: #6E7F95;
  font-size: 10px;
  font-weight: 400;
  margin-bottom: 45px;
}

a {
  text-decoration: underline;
}

.logo {
  max-width: 80px;
}
</style>